import { Amplify } from "aws-amplify";
import "aws-amplify/auth/enable-oauth-listener";
import { env } from "@/lib/env";

let configured = false;

export function configureAmplify(): void {
  if (configured) return;
  if (!env.cognitoUserPoolId || !env.cognitoAppClientId) {
    // Allow the app to boot in unit-test/dev environments without Cognito.
    configured = true;
    return;
  }
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: env.cognitoUserPoolId,
        userPoolClientId: env.cognitoAppClientId,
        loginWith: {
          oauth: {
            domain: env.cognitoDomain,
            scopes: ["openid", "email", "profile"],
            redirectSignIn: [`${window.location.origin}/auth/callback`],
            redirectSignOut: [`${window.location.origin}/`],
            responseType: "code",
          },
        },
      },
    },
  });
  configured = true;
}
